export interface FilterItemValue {
    value: any;
    label: string;
    /** Group label, i.e. Country for a Region */
    group?: string;
    count?: number;
    data?: string;
}
